<div class="aucdt-nav-container">
  
  <div class="aucdt-nav-header">
    <div class="aucdt-nav-logo">
      <img alt="Techbridge Logo" src="https://techbridge.edu.gh/static/TUC_LOGO_1.png" loading="lazy">
    </div>
    <div class="aucdt-nav-university-name">
            <p>Techbridge</p>
      <p>Management Portal</p>
    </div>
  </div>

  <mat-divider></mat-divider>

  <div class="aucdt-nav-user-info" *ngIf="currentUserRole">
    <div class="aucdt-nav-user-avatar">
      <mat-icon>account_circle</mat-icon>
    </div>
    <div class="aucdt-nav-user-details">
      <p class="aucdt-nav-user-name">{{ userFullName }}</p>
      <p class="aucdt-nav-user-role">{{ getRoleDisplayName(currentUserRole) }}</p>
    </div>
  </div>

  <mat-divider></mat-divider>

  <div class="aucdt-nav-quick-stats" *ngIf="currentUserRole">
    <div class="aucdt-nav-stat-item">
      <mat-icon>dashboard</mat-icon>
      <span>{{ getMenuItemCount() }} Modules</span>
    </div>
  </div>

  <div class="aucdt-nav-menu">
    <mat-nav-list dense>
      <mat-accordion multi>
        <ng-container *ngFor="let item of menuItems; trackBy: trackByMenuItem">
          
          <mat-list-item 
            *ngIf="!isDropdown(item)" 
            [routerLink]="item.route" 
            routerLinkActive="active-link"
            [class.active-link]="isActiveRoute(item.route)"
            (click)="navigateTo(item.route!)">
            <mat-icon matListIcon [class.aucdt-nav-active-icon]="isActiveRoute(item.route)">
              {{ item.icon }}
            </mat-icon>
            <span matLine>{{ item.name }}</span>
            <mat-icon matSuffix *ngIf="isActiveRoute(item.route)" class="aucdt-nav-active-indicator">
              chevron_right
            </mat-icon>
          </mat-list-item>

          <mat-expansion-panel 
            *ngIf="isDropdown(item)" 
            hideToggle
            [expanded]="hasActiveChild(item.children)"
            class="aucdt-nav-expansion-panel">
            
            <mat-expansion-panel-header 
              class="aucdt-nav-dropdown-header"
              [class.aucdt-nav-active-dropdown]="hasActiveChild(item.children)">
              <mat-panel-title class="aucdt-nav-dropdown-title">
                <mat-icon 
                  matListIcon 
                  [class.aucdt-nav-active-icon]="hasActiveChild(item.children)">
                  {{ item.icon }}
                </mat-icon>
                <span class="aucdt-nav-menu-name">{{ item.name }}</span>
                <span class="aucdt-nav-menu-badge" *ngIf="item.children">
                  {{ item.children.length }}
                </span>
              </mat-panel-title>
            </mat-expansion-panel-header>

            <mat-nav-list dense class="aucdt-nav-sub-menu">
              <mat-list-item 
                *ngFor="let child of item.children; trackBy: trackByMenuItem" 
                [routerLink]="child.route" 
                routerLinkActive="active-sub-link"
                [class.active-sub-link]="isActiveRoute(child.route)"
                (click)="navigateTo(child.route!)">
                <mat-icon 
                  matListIcon 
                  class="aucdt-nav-sub-icon"
                  [class.aucdt-nav-active-icon]="isActiveRoute(child.route)">
                  radio_button_checked
                </mat-icon>
                <span matLine>{{ child.name }}</span>
                <mat-icon 
                  matSuffix 
                  *ngIf="isActiveRoute(child.route)" 
                  class="aucdt-nav-active-indicator">
                  chevron_right
                </mat-icon>
              </mat-list-item>
            </mat-nav-list>

          </mat-expansion-panel>

        </ng-container>
      </mat-accordion>
    </mat-nav-list>
  </div>

  <div class="aucdt-nav-footer">
    <mat-divider></mat-divider>
    
    <div class="aucdt-nav-quick-actions">
      <button mat-icon-button matTooltip="Refresh Menu" (click)="refreshMenu()">
        <mat-icon>refresh</mat-icon>
      </button>
      <button mat-icon-button matTooltip="Settings">
        <mat-icon>settings</mat-icon>
      </button>
      <button mat-icon-button matTooltip="Help">
        <mat-icon>help_outline</mat-icon>
      </button>
    </div>

   <div class="aucdt-nav-footer">
  <button 
    mat-raised-button 
    color="warn" 
    class="aucdt-nav-logout-button" 
    (click)="logout()"
    [disabled]="isLoggingOut"> <mat-icon>exit_to_app</mat-icon>
    
    <span *ngIf="!isLoggingOut">Logout</span>
    <mat-spinner *ngIf="isLoggingOut" [diameter]="20" color="primary"></mat-spinner>
    
  </button>
</div>
  </div>

  <div class="logout-overlay" *ngIf="isLoggingOut">
    <mat-spinner [diameter]="40" color="primary"></mat-spinner>
    <span>Logging Out...</span>
  </div>
  
</div>